import { Col, Form, Row, Select } from 'antd';
import React, { useMemo } from 'react';
import { useGetMediaTags } from '../../../../../utils/api/medias/useGetMediaTags';

const MEDIA_TYPES = [
  { label: 'Image', value: 'image' },
  { label: 'Vidéo', value: 'video' },
  { label: 'Document', value: 'document' },
];

const MEDIA_ORDER_OPTIONS = Array.from({ length: 30 }, (_, i) => ({
  label: `N° ${i + 1}`,
  value: i,
}));

const SelectMedia = ({ value, onChange, fieldNamePrefix = [] }) => {
  const { tags, isLoading } = useGetMediaTags();
  const form = Form.useFormInstance();

  const handleMediaTypeChange = (mediaType) => {
    onChange({
      ...value,
      media_type: mediaType,
    });
  };

  const tagOptions = useMemo(() => {
    if (!tags) return [];
    return tags.map((tag) => ({
      label: tag.name,
      value: tag.name,
    }));
  }, [tags]);

  const handleImageOrderChange = (imageOrder) => {
    onChange({
      ...value,
      image_order: imageOrder,
    });
  };

  const handleTagsChange = (tags) => {
    onChange({
      ...value,
      tags: tags,
    });
  };

  const validateImageOrder = (_, imageOrder) => {
    const tagsValue = form.getFieldValue([...fieldNamePrefix, 'tags']);
    const hasTags = tagsValue && tagsValue.length > 0;
    const hasImageOrder = imageOrder !== undefined && imageOrder !== null;

    if (!hasTags && !hasImageOrder) {
      return Promise.reject(
        new Error(
          "Veuillez renseigner soit l'ordre du média, soit les tags du média"
        )
      );
    }
    return Promise.resolve();
  };

  const validateTags = (_, tags) => {
    const imageOrderValue = form.getFieldValue([
      ...fieldNamePrefix,
      'image_order',
    ]);
    const hasTags = tags && tags.length > 0;
    const hasImageOrder =
      imageOrderValue !== undefined && imageOrderValue !== null;

    if (!hasTags && !hasImageOrder) {
      return Promise.reject(
        new Error(
          "Veuillez renseigner soit les tags du média, soit l'ordre du média"
        )
      );
    }
    return Promise.resolve();
  };

  return (
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item
          label="Type de média"
          name={[...fieldNamePrefix, 'media_type']}
          rules={[
            {
              required: true,
              message: 'Veuillez sélectionner un type de média',
            },
          ]}
          initialValue={value?.media_type}
        >
          <Select
            placeholder="Sélectionnez un type"
            options={MEDIA_TYPES}
            style={{ width: '100%' }}
            onChange={handleMediaTypeChange}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Ordre du média"
          name={[...fieldNamePrefix, 'image_order']}
          dependencies={[[...fieldNamePrefix, 'tags']]}
          rules={[{ validator: validateImageOrder }]}
          initialValue={value?.image_order}
        >
          <Select
            allowClear
            placeholder="Sélectionnez l'ordre"
            options={MEDIA_ORDER_OPTIONS}
            style={{ width: '100%' }}
            onChange={handleImageOrderChange}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Tags des médias"
          name={[...fieldNamePrefix, 'tags']}
          dependencies={[[...fieldNamePrefix, 'image_order']]}
          rules={[{ validator: validateTags }]}
          initialValue={value?.tags ?? []}
        >
          <Select
            mode={'tags'}
            placeholder="Sélectionnez un tag"
            onChange={handleTagsChange}
            options={tagOptions}
            loading={isLoading}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default SelectMedia;
